package Structs

import DataBase.UINKDBInterface
import kotlinx.serialization.Serializable
import myName

@myName("ClientDebt")
@Serializable
data class ClientDebt(
    val client_id: Int,
    val branch: Int = -1,
    val notes: Float?=null,
    val positive_carteset: Float=0f,
    val negative_carteset: Float=0f,
    val notes_amount: Float?=null,
    val notes_open: Float?=null,
    val taxNotes: Float?=null,
    val taxNotes_open: Float?=null,
    val tax_note_pays: Float?=null,
    val taxNotes_amount: Float?=null,
    val pay_notes: Float?=null,
    val pay_notes_amount: Float?=null,
    val openSumDue: Float?=null,
    val overdue_tax_notes: Float?=null,
    val value_left: Float?=null,
    var mdate_carteset: String?=null,
    var openSumDueMonth:Float?=null,
    var overdueMonth:Float?=null,
    var earliest_open_date: String?=null,
     var ind_upto_2weeks: Float?=null,
     var ind_upto_1month: Float?=null,
    var ind_from_1_5months: Float?=null,

) {
    var isClient=true
init {

    mdate_carteset= if(mdate_carteset=="0.0") null else mdate_carteset
    earliest_open_date= if(earliest_open_date=="0.0") null else earliest_open_date
}
}